import { Link } from "react-router-dom";

export function BrandMark({ className = "text-xl" }) {
  return (
    <Link to="/" className={`inline-flex items-baseline leading-none ${className}`} data-testid="brand-home-link" aria-label="The Paycheck Edit home">
      <span className="font-serif text-[#164C3B]">The Paycheck</span>
      <span className="font-script ml-[0.3em] text-[1.45em] leading-[0.6] text-[#C9A86A]">Edit</span>
      <span className="ml-[0.1em] self-start text-[0.5em] text-[#C9A86A]">™</span>
    </Link>
  );
}

export function JourneyTopBar({ showSignIn = true }) {
  return (
    <header className="sticky top-0 z-40 border-b border-[#E5E0D9] bg-[#FAF8F4]/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-[1120px] items-center justify-between px-5 sm:px-8">
        <BrandMark />
        {showSignIn && (
          <Link
            to="/login"
            data-testid="topbar-signin-link"
            className="text-sm font-medium text-[#164C3B] transition-colors hover:text-[#2F6B57] hover:underline"
          >
            Sign in
          </Link>
        )}
      </div>
    </header>
  );
}

export function JourneyFooter({ disclaimerTo = "/legal#disclaimer" }) {
  return (
    <footer className="border-t border-[#E5E0D9] bg-[#FAF8F4]">
      <div className="mx-auto flex w-full max-w-[1120px] flex-col gap-3 px-5 py-8 text-center sm:flex-row sm:items-center sm:justify-between sm:px-8 sm:text-left">
        <BrandMark className="text-base" />
        <div className="max-w-xl text-xs leading-relaxed text-[#70584A] sm:text-right">
          <p>
            The Paycheck Edit™ is an educational financial planning tool, not financial, investment, legal, tax,
            accounting, or credit advice, and it never moves your money. You decide and confirm every proposed money
            move it provides. Individual results vary and are not guaranteed.{" "}
            <Link to={disclaimerTo} data-testid="journey-footer-disclaimer" className="font-medium underline hover:text-[#164C3B]">Financial Disclaimer</Link>.
          </p>
          <p className="mt-1.5">© 2026 The Paycheck Edit™</p>
        </div>
      </div>
    </footer>
  );
}
